import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { select } from '@ngxs/store';
import { TranslateModule } from '@ngx-translate/core';
import {
    IroNamRequestStatus,
    OmEmeaRequestStatus,
    OmNamRequestStatus,
    RequestState
} from '@shs-digi-care-monorepo/interfaces';
import { statusPillColorMapRgb } from './config/status-color-map.config';
import { UserState } from '../../../states';

@Component({
    selector: 'app-requests-status-pill',
    templateUrl: './requests-status-pill.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RequestsStatusPillComponent {
    public status: InputSignal<RequestState | OmEmeaRequestStatus | OmNamRequestStatus | IroNamRequestStatus> =
        input.required<RequestState | OmEmeaRequestStatus | OmNamRequestStatus | IroNamRequestStatus>();
    public isOnHold: InputSignal<boolean> = input<boolean>(false);
    public size: InputSignal<'sm' | 'md' | 'lg'> = input<'sm' | 'md' | 'lg'>('md');

    protected statusColorMap = statusPillColorMapRgb;
    protected isInternal = select(UserState.isInternal);
}
